var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1392.9 1393.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.5.35c-111.6,7.9-211,38.8-302.5,94.2C148.2,196.15,34,368.35,6,562c-5.1,35.8-5.9,47.5-6,92.3,0,42.9.6,54.4,4.6,85a657.66,657.66,0,0,0,528.4,561c45.8,8.8,70.3,11,123,10.9,44.8,0,56.3-.7,92.5-5.9a661.5,661.5,0,0,0,296.8-122.2c6.1-4.5,12-8.3,12.9-8.3s46.7,44.8,102.8,100.9c55.5,55.4,103,102.2,105.5,103.8a100.24,100.24,0,0,0,24,11.5c6.4,2,9.6,2.3,22,2.3s15.6-.3,22-2.3c22.6-7.1,40.6-22.3,50.5-42.7,6.6-13.7,8-19.6,7.9-36,0-13.2-.2-14.6-3.2-23.5-7-20.5-1.8-14.6-113.9-127-55.7-55.9-101.3-102.3-101.3-103.2s4.3-7.5,9.5-14.7c69.1-94.7,111.9-205.1,123.9-320.1,9.8-92.8-.3-184.3-29.9-273.5-12-36.1-20.9-57.5-38-91.5-71.4-141.3-194.5-253.7-342.4-312.5C839.3,23.05,780.7,9,715.5,2.15,700.8.65,632.6-.65,618.5.35Zm78,163.5c84,7.6,161.1,34.4,229.9,79.6,27.9,18.3,49.5,35.8,74,59.8,86.5,84.7,137.7,195,147.1,316.4.5,7.4,1,23.7,1,36.1,0,54.9-8,104.8-25,156-30.4,91.3-86.1,170.7-162.9,231.8-60.2,48-136.8,82.8-213.7,97.1-32.5,6-55.7,8.1-91.4,8.1-44.5,0-77.6-3.9-118.9-14.1-141.5-34.8-262.1-132.5-325.1-263.4-57-118.3-65.1-250.4-23.2-374.5,49.1-145.2,164-259.6,309.7-308.5,46-15.5,86.9-23.1,138.5-25.9C646.5,161.85,684.7,162.75,696.5,163.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.20530128b6175ca1888e76a0af3048d6.svg";
export { ForwardRef as ReactComponent };